import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export const FOOTER_HEIGHT = 98;

export default makeStyles((theme: MuiTheme) => ({
  root: {
    ["z-index"]: `${theme.zIndex.modal - 1} !important`
  },
  dialogTitle: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: 0,
    borderBottom: `1px solid ${theme.palette.text.hint}`,
    height: 60
  },
  titleText: {
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    fontSize: 18
  },
  dialogContent: {
    padding: 0
  },
  workOrderDetailPaper: {
    width: "100%",
    maxWidth: "100%",
    height: "100%",
    margin: 0,
    borderRadius: 0
  },
  workOrderDetailScrollPaper: {
    maxHeight: "100%",
    ".MuiDialogContent-root:first-child": {
      padding: 0
    }
  },
  workOrderDetailActions: {
    display: "flex",
    justifyContent: "center",
    position: "fixed",
    bottom: 0,
    width: "100%",
    height: FOOTER_HEIGHT,
    background: theme.palette.common.white,
    borderTop: `1px solid ${theme.palette.text.hint}`,
    padding: 16,
    "&.MuiDialogActions-spacing > :not(:first-child)": {
      marginLeft: 16
    }
  },
  alert: {
    color: "#be1f32",
    borderColor: "#be1f32"
  },
  closeButton: {
    position: "absolute",
    padding: 8,
    right: 6,
    top: 10
  }
}));
